<h1 class="page__title my-5 h2">{{ 'mail_summary_send_title' | translate }}</h1>
<table class="table table-bordered b-l-none b-r-none">
  <tbody>
    <!-- Recipients section -->
    <tr>
      <td class="b-l-none align-top" translate>smsadv_summary_title</td>
      <td class="b-r-none">
        <!-- Gender -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_gender</div>
        <span class="f-s-14">{{ getGender() }}</span>
        <!-- Age -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_age</div>
        <span class="f-s-14">{{ getAgeRanges() }}</span>
        <!-- Area Geographic -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_area</div>
        <div>
          <span *ngIf="isRegion" class="f-s-14">{{ 'smsadv_summary_settings_recipients_area_regions' | translate }} {{ regionValue }}</span>
        </div>
        <div>
          <span *ngIf="isProvinces" class="f-s-14"
            >{{ 'smsadv_summary_settings_recipients_area_provinces' | translate }} {{ provincesValue }}</span
          >
        </div>
        <div>
          <span *ngIf="isZipCodes" class="f-s-14"
            >{{ 'smsadv_summary_settings_recipients_area_zip_codes' | translate }} {{ zipCodesValue }}</span
          >
        </div>
        <!-- Recipients available -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_number_available</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.countRecipients }}</span>
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_number_limit</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.limitRecipients }}</span>
      </td>
      <!-- Change Recipients btn -->
      <td class="b-x-none text-end">
        <button class="btn btn-custom btn-secondary btn-sm" (click)="routeToSelectRecipient()" translate>
          smsadv_summary_settings_edit_recipients
        </button>
      </td>
    </tr>
    <!-- Campaign section -->
    <tr>
      <td class="b-l-none align-top" translate>smsadv_summary_campaign</td>
      <td class="b-r-none">
        <!-- title -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_config_title</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.title }}</span>
        <!-- Text -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_config_text</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.message }}</span>
        <!-- Sender -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_config_sender</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.sender.valueSender }}</span>
        <!-- Send -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_config_sendtype</div>
        <span class="f-s-14">{{ getSending() }}</span>
        <!-- Recipients -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_recipients_number</div>
        <span class="f-s-14">{{ getRecipientCampaign() }}</span>
        <!-- Sent SMS -->
        <div class="font-weight-bold" translate>smsadv_summary_settings_messages_number</div>
        <span class="f-s-14">{{ smsAdvCampaignToSend?.fragmentsCount }}</span>
      </td>
      <td class="b-x-none text-end">
        <!-- EditCampaign button -->
        <div>
          <button class="btn btn-custom btn-secondary mb-3 btn-sm" (click)="routeToCreateCampaign()" translate>
            smsadv_summary_settings_edit_campaign
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</table>
